import './button.css';

const buttonStyles = {
  primary:
    'bg-primary text-black border border-lime ' +
    'hover:bg-black hover:text-primary hover:border-black dark:hover:bg-white dark:hover:text-black ' +
    'focus:bg-black focus:text-primary focus:border-black dark:focus:bg-white dark:focus:text-black ' +
    'active:bg-black-light active:text-primary active:border-black-light dark:active:bg-grey-10 dark:active:text-black ',
  secondary:
    'bg-white text-black border border-grey-30 dark:bg-black dark:border-grey-50 dark:text-white ' +
    'hover:bg-lime hover:border-lime dark:hover:bg-lime dark:hover:text-black dark:hover:border-lime ' +
    'focus:bg-lime focus:border-lime ' +
    'active:bg-lime-dark-1 active:border-lime-dark-1 ',
  tertiary:
    'text-white bg-black border border-black dark:bg-black ' +
    'hover:bg-bg-grey-70 hover:text-white hover:border-grey-70 dark:hover:text-black dark:hover:bg-white ' +
    'focus:bg-white focus:text-black focus:border-white ' +
    'active:bg-grey-10 active:text-black active:border-grey-10',
  negative:
    'bg-white text-negative border border-negative ' +
    'hover:bg-negative hover:text-white hover:border-negative ' +
    'focus:bg-negative focus:text-white focus:border-negative ' +
    'active:bg-negative-dark-1 active:text-white active:border-negative-dark-1',
  transparent:
    'text-black hover:font-bold focus:font-bold active:font-semibold dark:text-white',
};

const focusedButtonStyles = {
  primary: 'bg-black text-lime border-black hover:bg-black hover:text-lime',
  secondary: 'bg-lime border-lime text-black hover:bg-lime hover:text-black',
  tertiary: 'bg-white text-black hover:bg-white hover:text-black',
  transparent: 'font-bold text-black hover:font-bold hover:text-black',
};

const disabledButtonStyles = {
  primary:
    'bg-grey-10 text-grey-30 cursor-not-allowed pointer-events-none dark:bg-grey-80 dark:text-grey-70',
  secondary:
    'bg-grey-10 text-grey-30 cursor-not-allowed pointer-events-none dark:bg-grey-80 dark:text-grey-70',
  tertiary:
    'bg-grey-10 text-grey-30 cursor-not-allowed pointer-events-none dark:bg-grey-80 dark:text-grey-70',
  transparent:
    'text-grey-30 cursor-not-allowed pointer-events-none dark:bg-grey-80 dark:text-grey-70',
};

export interface ButtonProps {
  children: any;
  buttonClass?: string;
  type?: 'button' | 'submit' | 'reset';
  onClick?: any;
  loading?: boolean;
  size?: 'small' | 'large' | 'full';
  isFocused?: boolean;
  variant?: 'primary' | 'secondary' | 'tertiary' | 'negative' | 'transparent';
  disabled?: boolean;
}

export const Button = ({
  children,
  buttonClass = '',
  disabled,
  isFocused,
  loading,
  onClick,
  size = 'large',
  type = 'button',
  variant = 'transparent',
}: ButtonProps) => {
  return (
    <button
      type={type}
      onClick={() => !loading && !disabled && onClick && onClick()}
      disabled={disabled || loading}
      className={`
        inline-flex
        justify-center
        items-center
        font-semibold
        rounded-xl
        px-4
        ${buttonClass}
        ${
          disabled
            ? disabledButtonStyles[variant]
            : isFocused
            ? focusedButtonStyles[variant]
            : buttonStyles[variant]
        }
        ${
          size === 'small'
            ? 'text-xs h-8'
            : size === 'full'
            ? 'w-full text-base h-9'
            : 'text-sm h-9'
        }
      `}
    >
      {!loading ? (
        children
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 16 16"
          height="16"
          width="16"
          className="fill-current"
        >
          <g className="nc-icon-wrapper" stroke="none">
            <g className="nc-loop-dots-4-16-icon-f">
              <circle cx="3" cy="8" r="2"></circle>
              <circle cx="8" cy="8" r="2" data-color="color-2"></circle>
              <circle cx="13" cy="8" r="2"></circle>
            </g>
          </g>
        </svg>
      )}
    </button>
  );
};
